import { COLOR_ELEVATION_01 } from "../../config";
import {
  radius,
  spacing,

  COLOR_BACKGROUND,
  COLOR_ELEVATION,
  COLOR_PRIMARY_RED,
  COLOR_DISABLED,
  GREEN_GRADIENT,
} from "./../../styleConfig";
import styled from "styled-components";

interface IFormButton {
  error?: boolean;
  initialBorderColor?: string
}

export const FormButton = styled.button<IFormButton>`
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  padding: ${spacing(1.2)};
  color: white;
  font-weight: 700;
  font-size: 15px;
  outline: none;

  border: 2px solid ${p => p.initialBorderColor ?? COLOR_ELEVATION_01};

 ${(p) =>
    p.error
      ? COLOR_PRIMARY_RED
      : p.disabled ? COLOR_DISABLED : GREEN_GRADIENT}
  cursor: ${(p) => (p.disabled ? "no-drop" : "pointer")};
  transition: 0.12s;
  height: 50px;
  width: 100%;
  margin: ${spacing(1)};

  ${(p) => {
    if (p.disabled) {
      return {
        backgroundColor: COLOR_DISABLED,
        border: "2px solid transparent",
      };
    }
  }}

  &:hover {
    background: ${(p) => (p.disabled ? COLOR_DISABLED : "transparent")};
    color: ${(p) =>
      !p.error
        ? 'rgba(0,36,18,1)'
        : p.disabled
        ? COLOR_ELEVATION
        : COLOR_PRIMARY_RED};
          border: 2px solid rgba(0,36,18,1);
  }

`;
